import React from 'react';

const NoHiddenJobs = () => {
  return (
    <div className='flex flex-col items-center justify-center tabletH:max-w-[870px] w-full h-[380px] p-10'>
      <div className='text-text-placeholder pb-[60px] tabletH:pb-6 w-full text-center'>
        No hidden jobs
      </div>
    </div>
  );
};

export default NoHiddenJobs;
